import { isGroupOnlyAlarmType } from '@/interfaces/enums'
import {
  IAlarmByClassification,
  IAlarmBySensor,
  IClassificationMetrics,
} from '@/interfaces/stores/alarm'


export const UNDEFINED_SENSOR_LABEL = 'Sensor Indefinido'


export const UNDEFINED_CLASSIFICATION_LABEL = 'Indefinido'

function isDefinedClassification(name: string | undefined | null): boolean {
  if (name == null) return false
  return name.trim().toLowerCase() !== UNDEFINED_CLASSIFICATION_LABEL.toLowerCase()
}


export function filterDefinedClassificationMetrics<T extends { classification: string }>(
  rows: T[] | undefined | null,
): T[] {
  if (!rows?.length) return []
  return rows.filter((row) => isDefinedClassification(row.classification))
}

export function filterDefinedAlarmsByClassification(
  rows: IAlarmByClassification[] | undefined | null,
): IAlarmByClassification[] {
  return filterDefinedClassificationMetrics(rows)
}

export function filterDefinedClassificationDurationMetrics(
  rows: IClassificationMetrics[] | undefined | null,
): IClassificationMetrics[] {
  return filterDefinedClassificationMetrics(rows)
}

export function hasSensorBoundAlarmMetrics(alarmsBySensor: IAlarmBySensor[] | undefined | null): boolean {
  if (!alarmsBySensor?.length) return false

  return alarmsBySensor.some(
    (row) => row.alarm_count > 0 && row.sensor_name !== UNDEFINED_SENSOR_LABEL,
  )
}

export function isGroupOnlyAlarmTypeFilter(selectedTypes: string[]): boolean {
  if (!selectedTypes.length) return false

  return selectedTypes.every(isGroupOnlyAlarmType)
}


export function shouldShowAlarmsBySensorChart(
  alarmsBySensor: IAlarmBySensor[] | undefined | null,
  selectedAlarmTypes: string[],
): boolean {
  if (isGroupOnlyAlarmTypeFilter(selectedAlarmTypes)) return false

  return hasSensorBoundAlarmMetrics(alarmsBySensor)
}
